import React from 'react'

import graphql2chartjs from 'graphql2chartjs'

export const colors = ['#3366CC', '#DC3912', '#FF9900', '#109618', '#990099', '#3B3EAC', '#0099C6', 
'#DD4477', '#66AA00', '#B82E2E', '#316395', '#994499', '#22AA99', '#AAAA11', '#6633CC', 
'#E67300', '#8B0707', '#329262', '#5574A6', '#3B3EAC',];  

// ==========================================

export function getBaseChartBarLine(data, filter, chartType='bar', transpose=false, chartFill=false, sortFunction=null, dataPointProcessFunc=null) {
  const { bd: entries} = data

  let colorXdataset = {} // assign colors for each dataset
  let title = ""
  
  // process datapoints
  let entriesProc = entries
  if(dataPointProcessFunc != null){
    entriesProc = dataPointProcessFunc(entries)
  }

  // transpose
  let entriesRs = entriesProc
  if(transpose){
    entriesRs = {}
    Object.keys(entries).forEach(dataSetName => {      
          entries[dataSetName].forEach(datapoint => {            
            if(!entriesRs.hasOwnProperty(datapoint['filter'])) entriesRs[datapoint['filter']] = [];
            entriesRs[datapoint['filter']].push({...datapoint, filter: dataSetName});
          });
    });
  }  

  // let filter = props.filter || {key: Object.keys(entries)[0], label: Object.keys(entries)[0]} ;
  // let entriesRs = entries;  

  // set colors to datasets
  let i = 0;
  Object.keys(entriesRs).forEach(dataSetName => {
      if (i>=colors.length) i = 0; // reset colors index
      colorXdataset[dataSetName] = colors[i];
      i++;
  });    

  // filter if passsed as parameter
  let filteredEntries = {...entriesRs};
  if(filter!=null && filter!='' ){
    let filterName = 'filter'
    if(typeof filter === 'object' && Object.keys(filter).includes('filterName') && Object.keys(filter).includes('value') ){ // namedFilters (for more than a filterField)
      filterName = filter.filterName
      filter = filter.value      
    }

    if(filter!=null && filter!='' ){
      // filteredEntries = {...entriesRs}; // clone original object     
      let acceptedKeys = Array.isArray(filter) ? filter : [filter]    
      acceptedKeys = acceptedKeys.map(e => typeof e === 'object' && 'key' in e ?  e.key : e)
      Object.keys(entriesRs).forEach(dataSetName => {
        // filteredEntries[dataSetName] = entriesRs[dataSetName].filter(e => acceptedKeys.includes(e['filter']) );    
        filteredEntries[dataSetName] = entriesRs[dataSetName].filter(e => acceptedKeys.includes(e[filterName]) );    
      });
      title = acceptedKeys.join(' & ');
    }
  }


  // sort 
  if(sortFunction){
    if(typeof sortFunction == 'number'){ // loop over available fields      
      if(filteredEntries[Object.keys(filteredEntries)[0]].length){
        try {
          let sortfields = Object.keys(filteredEntries[Object.keys(filteredEntries)[0]][0])
          i = sortFunction < sortfields.length ? sortFunction : sortFunction % sortfields.length; // cyclic
          Object.keys(filteredEntries).forEach(dataSetName => {
            filteredEntries[dataSetName].sort((a, b) => {
              return (Number.isNaN(a[sortfields[i]] - b[sortfields[i]]) ? ( a[sortfields[i]] > b[sortfields[i]] ? 1 : (a[sortfields[i]] < b[sortfields[i]] ? -1 : 0)  ) : a[sortfields[i]] - b[sortfields[i]]  )
            });
            // return; // apparently only the first dataset is needed
          });                  
        } catch (error) {
          console.error(error);
        }                
      }
    }
    else if(typeof sortFunction == 'string'){ // field to sort by
      Object.keys(filteredEntries).forEach(dataSetName => {
        filteredEntries[dataSetName].sort((a, b) => a[sortFunction] - b[sortFunction]);
      });
    }
    else{ // sort function
      Object.keys(filteredEntries).forEach(dataSetName => {
        filteredEntries[dataSetName].sort((a, b) => a.data - b.data);
      });    
    }    
  } // -----

  let chartTypeVar = ['bar', 'line', 'radar'].includes(chartType) ? chartType : 'bar';

  // -------------------------
  const g2c = new graphql2chartjs();
  // add graphql data to graphql2chartjs instance while adding different chart types and properties
  g2c.add(filteredEntries, (dataSetName, dataPoint) => {
      let vColor = chartFill ? convertHex(colorXdataset[dataSetName], 30) : colorXdataset[dataSetName];

      return {
          ...dataPoint,
          chartType: chartTypeVar,
          borderColor: vColor,
          pointBackgroundColor: vColor,
          backgroundColor: vColor,
          fill: chartFill
      }
  }); 

  // fix accents in series legends
  if ( Object.keys(g2c.data).includes('datasets') ){
    let modMap = {'aaa': 'á', 'eee': 'é', 'iii': 'í', 'ooo': 'ó', 'uuu': 'ú' }
    for (let i = 0; i < g2c.data['datasets'].length; i++) {      
      let label = g2c.data['datasets'][i]['label']
      Object.keys(modMap).forEach(mmKey => {
        label = label.replace(mmKey, modMap[mmKey]).replace(mmKey.toUpperCase(), modMap[mmKey].toUpperCase())
      });
      g2c.data['datasets'][i]['label'] = label      
    }
  }


  return {data: g2c.data, title: title};
}

// ==========================================
export function spreadDatapoints(entries){
  /* Each data point is spread in as many datapoints as fields found
  where the name of the field is used as label and the value as data in 
  the new datapoint
  {Q1: 233, Q2: 455} => {label: 'Q1', data: 233}, {label: 'Q2', data: 455}
  */
 
  // const { bd: entries} = data
  let rs = {}
  Object.keys(entries).forEach(dataSetName => {
    let tmpds = [] //{}
    let idx = 0
    entries[dataSetName].forEach(datapoint => {
      Object.keys(datapoint).forEach(dpfield => {
        if(dpfield != 'filter'){
          // tmpds[idx] = {label: dpfield, data: datapoint[dpfield], filter: datapoint.filter}
          tmpds.push( {label: dpfield, data: datapoint[dpfield], filter: datapoint.filter} );
          idx++;
        }
      })        
    })
    rs[dataSetName] = tmpds;
  })

  return rs;
}

// ==========================================

export function convertHex( hex, opacity ) {
  hex = hex.replace('#','');
  let r = parseInt(hex.substring(0,2), 16);
  let g = parseInt(hex.substring(2,4), 16);
  let b = parseInt(hex.substring(4,6), 16);

  let result = 'rgba('+r+','+g+','+b+','+opacity/100+')';
  return result;
}


// ==========================================


export function withChartUtils(WrappedComponent) {
  // return class ChartUtils extends React.Component {
  return class extends React.Component {

    // static colors = ['#3366CC', '#DC3912', '#FF9900', '#109618', '#990099', '#3B3EAC', '#0099C6', 
    // '#DD4477', '#66AA00', '#B82E2E', '#316395', '#994499', '#22AA99', '#AAAA11', '#6633CC', 
    // '#E67300', '#8B0707', '#329262', '#5574A6', '#3B3EAC',];  


    constructor(props) {
      super(props);
      // this.handleChange = this.handleChange.bind(this);
      // this.state = {
      //   data: selectData(DataSource, props)
      // };
    }

    // componentDidMount() {
    //   // ... that takes care of the subscription...
    //   DataSource.addChangeListener(this.handleChange);
    // }

    // componentWillUnmount() {
    //   DataSource.removeChangeListener(this.handleChange);
    // }

    // handleChange() {
    //   this.setState({
    //     data: selectData(DataSource, this.props)
    //   });
    // }

    getColors(num = 20) {
      console.log("Getting Colors-->A", )
      console.log("Getting Colors-->", this.colors)
      this.colors.slice(0, num)
    }    

    componentDidUpdate(prevProps) {
      // console.log('Current props: ', this.props);
      // console.log('Previous props: ', prevProps);
      // console.log("THE COLORS-->", colors)
    }

    render(){
      // return function ChartUtils({ isLoading, ...props }) {
        // if (!isLoading) return <Component {...props} />;        
        return <WrappedComponent getColors={this.getColors} {...this.props} />;
    }
  }
}

